

























import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import PasswordProtected from "@/components/PasswordProtected.vue";

export default Vue.extend({
  components: {
    PasswordProtected,
  },
  data() {
    return {
      self: this,
      item: null,
      currentTab: "",
      permitted: false,
      tabs: {
        accounts: {
          label: "Tài khoản ngân hàng",
          condition() {
            return userManager.checkRole(["kt"]);
          },
        },
      },
    };
  },
  async created() {
    this.item = await coreApiClient.call(
      "paymentPartners",
      "findById",
      {
        id: this.$route.params.paymentPartnerId,
      },
      undefined,
      undefined,
      "viewProtectedPage3"
    );
  },
});
